import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";
import CMSService from "@/services/CMSService.js";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic,
            pageTitle: "",
            pageContent: ""
        };
    },
    metaInfo() {
        return {
            title: `Política de cookies de YourDictionary`,
            meta: [
                {
                    name: "description",
                    content: `Página de la política de cookies de YourDictionary`
                }
            ]
        };
    },
    methods: {
        fetchContent() {
            CMSService.getCookiesYDR().then(
                response => {
                    const data = response.data.data;
                    this.pageTitle = data.title;
                    this.pageContent = data.body;
                },
                err => {
                    this.status.err = true;
                }
            );
        }
    },
    mounted() {
        this.fetchContent();
    }
};



// WEBPACK FOOTER //
// ./src/pages/PoliticaDeCookies/PoliticaDeCookies.js